(function () {
  if (window.__bottleAddonsFixInitialized) return;
  window.__bottleAddonsFixInitialized = true;

  var selectionsByRoot = {};
  var isAdding = false;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function getSelections(rootId) {
    if (!selectionsByRoot[rootId]) selectionsByRoot[rootId] = {};
    return selectionsByRoot[rootId];
  }

  function setLabel(root, group, tile) {
    var labelEl = root.querySelector('[data-addon-group-label="' + group + '"]');
    if (!labelEl) return;

    if (!tile) {
      labelEl.textContent = '';
      return;
    }

    var price = Number(tile.getAttribute('data-price')) || 0;
    var name = tile.getAttribute('data-label');
    var priceText = price > 0 ? formatMoney(price) : '';
    labelEl.textContent = name + (priceText ? ' (+' + priceText + ')' : '');
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function syncCartDisplay() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var totalEl = document.getElementById('cart-drawer-total');
        if (totalEl) {
          totalEl.textContent = formatMoney(cart.total_price);
        }

        document.querySelectorAll('cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });

        return cart;
      })
      .catch(function () { return null; });
  }

  function addOneWithRetry(variantId, properties, attemptsLeft) {
    if (attemptsLeft === undefined) attemptsLeft = 2;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: 1,
          properties: properties
        }]
      })
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('add failed with status ' + res.status);
      }
      return res.json();
    }).catch(function (err) {
      if (attemptsLeft > 1) {
        return wait(400).then(function () {
          return addOneWithRetry(variantId, properties, attemptsLeft - 1);
        });
      }
      throw err;
    });
  }

  function cleanupOrphanedAddons() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var realProductTitles = cart.items
          .filter(function (item) { return !(item.properties && item.properties['_addon_for']); })
          .map(function (item) { return item.product_title; });

        var hasAnyRealProduct = realProductTitles.length > 0;

        var keysToRemove = cart.items
          .filter(function (item) {
            var parentTitle = item.properties && item.properties['_addon_for'];
            if (!parentTitle) return false;
            if (!hasAnyRealProduct) return true;
            return realProductTitles.indexOf(parentTitle) === -1;
          })
          .map(function (item) { return item.key; });

        if (!keysToRemove.length) return;

        var chain = Promise.resolve();

        keysToRemove.forEach(function (key) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          });
        });

        return chain.then(syncCartDisplay);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var tile = event.target.closest('.addon-tile--large');
    if (tile) {
      var root = tile.closest('[id^="bottle-addons-"]');
      if (!root) return;

      var group = tile.getAttribute('data-addon-group');
      var variantId = tile.getAttribute('data-variant-id');
      var selections = getSelections(root.id);

      root.querySelectorAll('.addon-tile[data-addon-group="' + group + '"]').forEach(function (t) {
        t.classList.remove('is-selected');
      });
      tile.classList.add('is-selected');

      if (variantId) {
        selections[group] = variantId;
      } else {
        delete selections[group];
      }

      setLabel(root, group, tile);
      return;
    }

    var trigger = event.target.closest('[form]');
    if (trigger) {
      if (isAdding) return;

      var formId = trigger.getAttribute('form');
      var addonsRoot = document.querySelector('[data-product-form="' + formId + '"]');

      if (addonsRoot && addonsRoot.id && addonsRoot.id.indexOf('bottle-addons-') === 0) {
        var rootSelections = getSelections(addonsRoot.id);
        var groups = Object.keys(rootSelections);

        if (groups.length) {
          isAdding = true;

          var productTitle = addonsRoot.getAttribute('data-product-title');

          var chain = wait(500);

          groups.forEach(function (group) {
            chain = chain.then(function () {
              return addOneWithRetry(rootSelections[group], {
                '_addon_for': productTitle,
                '_addon_group': group
              }).then(function () {
                return wait(300);
              });
            });
          });

          chain
            .then(syncCartDisplay)
            .then(function () {
              document.dispatchEvent(new CustomEvent('cart:updated'));

              selectionsByRoot[addonsRoot.id] = {};

              addonsRoot.querySelectorAll('.addon-tile--large').forEach(function (t) {
                t.classList.remove('is-selected');
              });

              addonsRoot.querySelectorAll('.addon-tile--none').forEach(function (t) {
                t.classList.add('is-selected');
              });

              var engraveCheckbox = addonsRoot.querySelector('.addon-engrave__checkbox');
              if (engraveCheckbox) engraveCheckbox.checked = false;

              addonsRoot.querySelectorAll('[data-addon-group-label]').forEach(function (labelEl) {
                labelEl.textContent = '';
              });
            })
            .catch(function () {})
            .finally(function () {
              isAdding = false;
            });
        }
      }
      return;
    }
  });

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('.addon-engrave__checkbox');
    if (!checkbox) return;

    var root = checkbox.closest('[id^="bottle-addons-"]');
    if (!root) return;

    var selections = getSelections(root.id);

    if (checkbox.checked) {
      selections.engrave = checkbox.getAttribute('data-variant-id');
    } else {
      delete selections.engrave;
    }
  });

  // Watch the cart drawer's DOM directly for ANY change — catches item
  // removal regardless of what link/button structure actually triggers
  // it, instead of guessing at a specific "Remove" selector.
  var cleanupRunning = false;
  var cleanupDebounce;

  function debouncedCleanup() {
    clearTimeout(cleanupDebounce);
    cleanupDebounce = setTimeout(function () {
      if (cleanupRunning) return;
      cleanupRunning = true;
      cleanupOrphanedAddons().finally(function () {
        cleanupRunning = false;
      });
    }, 400);
  }

  var cartObserver = new MutationObserver(function () {
    debouncedCleanup();
  });

  cartObserver.observe(document.body, { childList: true, subtree: true });
})();